import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { withSpinner } from "../../extensions/withSpinner.extension";
import { API_ROOT } from "../../types/constants/appconstants";

@Injectable({
    "providedIn": "root"
})
export class PublicService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private publicBaseUrl = this.apiRoot + "api/public";

    downloadFile(encodedIds: string): Observable<string> {
        return withSpinner(this.http).post<string>(`${this.publicBaseUrl}/downloadfile/${encodedIds}`, null);
    }
}